export default __webpack_public_path__ + "static/media/address.d2fc9e11.svg";